var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Header'),_c('div',{staticClass:"content"},[_c('Logo',{attrs:{"subTitle":"Consulta de Solicitudes de Carta de no Adeudo","description":""}}),_c('NoDebtCertificateRequested')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }